/* eslint-disable no-unexpected-multiline */
/* eslint-disable no-empty */
/* eslint-disable node/no-callback-literal */
/* eslint-disable no-unmodified-loop-condition */
/* eslint-disable no-new-func */
/* eslint-disable prefer-regex-literals */
/* eslint-disable no-extend-native */
/* eslint-disable no-extra-parens */
/* eslint-disable no-unreachable-loop */
/* eslint-disable no-control-regex */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-cond-assign */
/* eslint-disable no-extra-semi */
/* eslint-disable eqeqeq */
/* eslint-disable indent */
/* eslint-disable no-useless-escape */
/* eslint-disable no-eval */
/* eslint-disable no-global-assign */
/* eslint-disable camelcase */
/* eslint-disable new-cap */
/* eslint-disable no-prototype-builtins */

Ext = {
  version: '3.4.1.1',
  versionDetail: {
    major: 3,
    minor: 4,
    patch: 1.1
  }
}

Ext.apply = function (o, c, defaults) {
  // no "this" reference for friendly out of scope calls
  if (defaults) {
    Ext.apply(o, defaults)
  }
  if (o && c && typeof c === 'object') {
    for (const p in c) {
      o[p] = c[p]
    }
  }
  return o
}

let idSeed = 0
const toString = Object.prototype.toString
const ua = navigator.userAgent.toLowerCase()
const check = function (r) {
  return r.test(ua)
}
const DOC = document
const isStrict = DOC.compatMode == 'CSS1Compat'
const isChrome = check(/\bchrome\b/)
const isWebKit = check(/webkit/)
const isSafari = !isChrome && check(/safari/)
const isGecko = !isWebKit && check(/gecko/)
const isBorderBox = false
const isWindows = check(/windows|win32/)
const isSecure = /^https/i.test(window.location.protocol)
const noArgs = []
let nonEnumerables = []
const emptyFn = Ext.emptyFn
const t = Ext.apply(
  {},
  {
    constructor: emptyFn,
    toString: emptyFn,
    valueOf: emptyFn
  }
)
const callOverrideParent = function () {
  const method = callOverrideParent.caller.caller // skip callParent (our caller)
  return method.$owner.prototype[method.$name].apply(this, arguments)
}

if (t.constructor !== emptyFn) {
  nonEnumerables.push('constructor')
}
if (t.toString !== emptyFn) {
  nonEnumerables.push('toString')
}
if (t.valueOf !== emptyFn) {
  nonEnumerables.push('valueOf')
}
if (!nonEnumerables.length) {
  nonEnumerables = null
}

function Base() {}
Ext.apply(Base, { $isClass: true })

Base.prototype = {
  constructor: function () {},
  // TODO slowly move away from this function by:
  // - using xxx.superclass.open.call(this, ...) // for functions
  // - xxx.bind(this)(cfg) // for constructors
  // because we should avoid using the ES5 deprecated `caller` fn
  callParent: function (args) {
    let method = this.callParent.caller

    if (!method) return

    let superMethod

    if (method.$previous) {
      superMethod = method.$previous
    } else {
      method = method.$owner ? method : method.caller
      superMethod = method && method.$owner.superclass[method.$name]
    }

    return superMethod.apply(this, args || noArgs)
  }
}

Ext.apply(Ext, {
  /**
   * URL to a blank file used by Ext when in secure mode for iframe src and onReady src to prevent
   * the IE insecure content warning (<tt>'about:blank'</tt>, except for IE in secure mode, which is <tt>'javascript:""'</tt>).
   * @type String
   */
  SSL_SECURE_URL: 'about:blank',
  /**
   * True if the browser is in strict (standards-compliant) mode, as opposed to quirks mode
   * @type Boolean
   */
  isStrict: isStrict,
  /**
   * True if the page is running over SSL
   * @type Boolean
   */
  isSecure: isSecure,
  /**
   * True when the document is fully initialized and ready for action
   * @type Boolean
   */
  isReady: false,

  /**
   * True if the {@link Ext.Fx} Class is available
   * @type Boolean
   * @property enableFx
   */

  /**
   * HIGHLY EXPERIMENTAL
   * True to force css based border-box model override and turning off javascript based adjustments. This is a
   * runtime configuration and must be set before onReady.
   * @type Boolean
   */
  enableForcedBoxModel: false,

  /**
   * True to automatically uncache orphaned Ext.Elements periodically (defaults to true)
   * @type Boolean
   */
  enableGarbageCollector: true,

  /**
   * True to automatically purge event listeners during garbageCollection (defaults to false).
   * @type Boolean
   */
  enableListenerCollection: false,

  /**
   * EXPERIMENTAL - True to cascade listener removal to child elements when an element is removed.
   * Currently not optimized for performance.
   * @type Boolean
   */
  enableNestedListenerRemoval: false,

  /**
   * Indicates whether to use native browser parsing for JSON methods.
   * This option is ignored if the browser does not support native JSON methods.
   * <b>Note: Native JSON methods will not work with objects that have functions.
   * Also, property names must be quoted, otherwise the data will not parse.</b> (Defaults to false)
   * @type Boolean
   */
  USE_NATIVE_JSON: false,

  /**
   * Copies all the properties of config to obj if they don't already exist.
   * @param {Object} obj The receiver of the properties
   * @param {Object} config The source of the properties
   * @return {Object} returns obj
   */
  applyIf: function (o, c) {
    if (o) {
      for (const p in c) {
        if (!Ext.isDefined(o[p])) {
          o[p] = c[p]
        }
      }
    }
    return o
  },

  id: function (el, prefix) {
    el = Ext.getDom(el, true) || {}
    if (!el.id) {
      el.id = (prefix || 'ext-gen') + ++idSeed
    }
    return el.id
  },

  extend: (function () {
    // inline overrides
    const io = function (o) {
      for (const m in o) {
        this[m] = o[m]
      }
    }
    const oc = Object.prototype.constructor

    return function (sb, sp, overrides) {
      if (typeof sp === 'object') {
        overrides = sp
        sp = sb
        sb =
          overrides.constructor != oc
            ? overrides.constructor
            : function () {
                sp.apply(this, arguments)
              }
      }
      const F = function () {}
      const spp = sp.prototype

      F.prototype = spp
      const sbp = (sb.prototype = new F())
      sbp.constructor = sb
      sb.superclass = spp
      if (spp.constructor == oc) {
        spp.constructor = sp
      }
      sb.override = function (o) {
        Ext.override(sb, o)
      }
      sbp.superclass = sbp.supr = function () {
        return spp
      }
      sbp.override = io
      Ext.override(sb, overrides)
      sb.extend = function (o) {
        return Ext.extend(sb, o)
      }
      return sb
    }
  })(),

  global: (function () {
    return this
  })(),

  Base: Base,

  namespaceCache: {},

  createNamespace: function (namespaceOrClass, isClass) {
    const cache = Ext.namespaceCache
    const namespace = isClass
      ? namespaceOrClass.substring(0, namespaceOrClass.lastIndexOf('.'))
      : namespaceOrClass
    let ns = cache[namespace]
    let i
    let n
    let part
    let parts
    let partials

    if (!ns) {
      ns = Ext.global
      if (namespace) {
        partials = []
        parts = namespace.split('.')

        for (i = 0, n = parts.length; i < n; ++i) {
          part = parts[i]

          ns = ns[part] || (ns[part] = {})
          partials.push(part)

          cache[partials.join('.')] = ns // build up prefixes as we go
        }
      }
    }

    return ns
  },

  getClassByName: function (className) {
    const parts = className.split('.')
    let cls = Ext.global
    const n = parts.length
    let i

    for (i = 0; cls && i < n; ++i) {
      cls = cls[parts[i]]
    }

    return cls || null
  },

  addMembers: function (cls, target, members, handleNonEnumerables) {
    let i, name, member

    for (name in members) {
      if (members.hasOwnProperty(name)) {
        member = members[name]
        if (typeof member === 'function') {
          member.$owner = cls
          member.$name = name
        }

        target[name] = member
      }
    }

    if (handleNonEnumerables && nonEnumerables) {
      // eslint-disable-next-line space-in-parens
      for (i = nonEnumerables.length; i-- > 0; ) {
        name = nonEnumerables[i]
        if (members.hasOwnProperty(name)) {
          member = members[name]
          if (typeof member === 'function') {
            member.$owner = cls
            member.$name = name
          }

          target[name] = member
        }
      }
    }
  },

  define: function (className, body, createdFn) {
    const override = body.override
    let cls
    let extend
    let name
    let namespace

    if (override) {
      delete body.override
      cls = Ext.getClassByName(override)
      Ext.override(cls, body)
    } else {
      if (className) {
        namespace = Ext.createNamespace(className, true)
        name = className.substring(className.lastIndexOf('.') + 1)
      }

      cls = function ctor() {
        // eslint-disable-next-line no-useless-catch
        try {
          this.constructor.apply(this, arguments)
        } catch (exc) {
          // since SCL-2338; prevents from cycling endlessly,
          // exceeding max stack size
          throw exc
        }
      }

      if (className) {
        cls.displayName = className
      }
      cls.$isClass = true
      cls.callParent = Ext.Base.callParent

      if (typeof body === 'function') {
        body = body(cls)
      }

      extend = body.extend
      if (extend) {
        delete body.extend
        if (typeof extend === 'string') {
          extend = Ext.getClassByName(extend)
        }
      } else {
        extend = Base
      }

      Ext.extend(cls, extend, body)
      if (cls.prototype.constructor === cls) {
        delete cls.prototype.constructor
      }

      // Not extending a class which derives from Base...
      if (!cls.prototype.$isClass) {
        Ext.applyIf(cls.prototype, Base.prototype)
      }
      cls.prototype.self = cls

      if (body.xtype) {
        Ext.reg(body.xtype, cls)
      }
      cls = body.singleton ? new cls() : cls
      if (className) {
        namespace[name] = cls
      }
    }

    if (createdFn) {
      createdFn.call(cls)
    }

    return cls
  },

  override: function (target, overrides) {
    let proto, statics

    if (overrides) {
      if (target.$isClass) {
        statics = overrides.statics
        if (statics) {
          delete overrides.statics
        }

        Ext.addMembers(target, target.prototype, overrides, true)
        if (statics) {
          Ext.addMembers(target, target, statics)
        }
      } else if (typeof target === 'function') {
        proto = target.prototype
        Ext.apply(proto, overrides)
      } else {
        const owner = target.self
        let name
        let value

        if (owner && owner.$isClass) {
          for (name in overrides) {
            if (overrides.hasOwnProperty(name)) {
              value = overrides[name]

              if (typeof value === 'function') {
                // <debug>
                if (owner.$className) {
                  value.displayName = owner.$className + '#' + name
                }
                // </debug>

                value.$name = name
                value.$owner = owner
                value.$previous = target.hasOwnProperty(name)
                  ? target[name] // already hooked, so call previous hook
                  : callOverrideParent // calls by name on prototype
              }

              target[name] = value
            }
          }
        } else {
          Ext.apply(target, overrides)

          if (!target.constructor.$isClass) {
            target.constructor.prototype.callParent = Base.prototype.callParent
            target.constructor.callParent = Base.callParent
          }
        }
      }
    }
  },

  namespace: function () {
    const len1 = arguments.length
    let i = 0
    let len2
    let j
    let ns
    let sub
    let current

    for (; i < len1; ++i) {
      ns = arguments[i].split('.')
      current = window[ns[0]]
      if (current === undefined) {
        current = window[ns[0]] = {}
      }
      sub = ns.slice(1)
      len2 = sub.length
      for (j = 0; j < len2; ++j) {
        current = current[sub[j]] = current[sub[j]] || {}
      }
    }
    return current
  },

  urlEncode: function (o, pre) {
    let empty
    const buf = []
    const e = encodeURIComponent

    Ext.iterate(o, function (key, item) {
      empty = Ext.isEmpty(item)
      Ext.each(empty ? key : item, function (val) {
        buf.push(
          '&',
          e(key),
          '=',
          !Ext.isEmpty(val) && (val != key || !empty)
            ? Ext.isDate(val)
              ? Ext.encode(val).replace(/"/g, '')
              : e(val)
            : ''
        )
      })
    })
    if (!pre) {
      buf.shift()
      pre = ''
    }
    return pre + buf.join('')
  },

  urlDecode: function (string, overwrite) {
    if (Ext.isEmpty(string)) {
      return {}
    }
    const obj = {}
    const pairs = string.split('&')
    const d = decodeURIComponent
    let name
    let value
    Ext.each(pairs, function (pair) {
      pair = pair.split('=')
      name = d(pair[0])
      value = d(pair[1])
      obj[name] = overwrite || !obj[name] ? value : [].concat(obj[name]).concat(value)
    })
    return obj
  },

  urlAppend: function (url, s) {
    if (!Ext.isEmpty(s)) {
      return url + (url.indexOf('?') === -1 ? '?' : '&') + s
    }
    return url
  },

  toArray: (function () {
    return function (a, i, j) {
      return Array.prototype.slice.call(a, i || 0, j || a.length)
    }
  })(),

  isIterable: function (v) {
    if (Array.isArray(v)) {
      return true
    }

    // check for node list type
    if (/NodeList|HTMLCollection/.test(toString.call(v))) {
      return true
    }
    // NodeList has an item and length property
    // IXMLDOMNodeList has nextNode method, needs to be checked first.
    return (typeof v.nextNode !== 'undefined' || v.item) && Ext.isNumber(v.length)
  },

  each: function (array, fn, scope) {
    if (Ext.isEmpty(array, true)) {
      return
    }
    if (!Ext.isIterable(array) || Ext.isPrimitive(array)) {
      array = [array]
    }
    for (let i = 0, len = array.length; i < len; i++) {
      if (fn.call(scope || array[i], array[i], i, array) === false) {
        return i
      }
    }
  },

  iterate: function (obj, fn, scope) {
    if (Ext.isEmpty(obj)) {
      return
    }
    if (Ext.isIterable(obj)) {
      Ext.each(obj, fn, scope)
    } else if (typeof obj === 'object') {
      for (const prop in obj) {
        if (obj.hasOwnProperty(prop)) {
          if (fn.call(scope || obj, prop, obj[prop], obj) === false) {
            return
          }
        }
      }
    }
  },

  getDom: function (el, strict) {
    if (!el || !DOC) {
      return null
    }
    if (el.dom) {
      return el.dom
    }
    if (typeof el === 'string') {
      const e = DOC.getElementById(el)

      return e
    }
    return el
  },

  getBody: function () {
    return Ext.get(DOC.body || DOC.documentElement)
  },

  getHead: (function () {
    let head

    return function () {
      if (head == undefined) {
        head = Ext.get(DOC.getElementsByTagName('head')[0])
      }

      return head
    }
  })(),

  removeNode: function (n) {
    if (n && n.parentNode && n.tagName != 'BODY') {
      Ext.enableNestedListenerRemoval
        ? Ext.EventManager.purgeElement(n, true)
        : Ext.EventManager.removeAll(n)
      n.parentNode.removeChild(n)
      delete Ext.elCache[n.id]
    }
  },

  isEmpty: function (v, allowBlank) {
    return (
      v === null ||
      v === undefined ||
      (Array.isArray(v) && !v.length) ||
      (!allowBlank ? v === '' : false)
    )
  },

  isDate: function (v) {
    return toString.apply(v) === '[object Date]'
  },

  isObject: function (v) {
    return !!v && Object.prototype.toString.call(v) === '[object Object]'
  },

  isPrimitive: function (v) {
    return Ext.isString(v) || Ext.isNumber(v) || Ext.isBoolean(v)
  },

  isFunction: function (v) {
    return toString.apply(v) === '[object Function]'
  },

  isNumber: function (v) {
    return typeof v === 'number' && isFinite(v)
  },

  isString: function (v) {
    return typeof v === 'string'
  },

  isBoolean: function (v) {
    return typeof v === 'boolean'
  },

  isElement: function (v) {
    return v ? !!v.tagName : false
  },

  isDefined: function (v) {
    return typeof v !== 'undefined'
  },

  isWebKit: isWebKit,
  isChrome: isChrome,
  isSafari: isSafari,
  isGecko: isGecko,
  isBorderBox: isBorderBox,
  isWindows: isWindows
})

Ext.ns = Ext.namespace

Ext.ns('Ext.util', 'Ext.lib', 'Ext.data', 'Ext.supports')

Ext.elCache = {}

Ext.apply(Function.prototype, {
  createInterceptor: function (fcn, scope) {
    const method = this
    return !Ext.isFunction(fcn)
      ? this
      : function () {
          const me = this
          const args = arguments
          fcn.target = me
          fcn.method = method
          return fcn.apply(scope || me || window, args) !== false
            ? method.apply(me || window, args)
            : null
        }
  },

  createCallback: function (/* args... */) {
    // make args available, in function below
    const args = arguments
    const method = this
    return function () {
      return method.apply(window, args)
    }
  },

  createDelegate: function (obj, args, appendArgs) {
    const method = this
    return function () {
      let callArgs = args || arguments
      if (appendArgs === true) {
        callArgs = Array.prototype.slice.call(arguments, 0)
        callArgs = callArgs.concat(args)
      } else if (Ext.isNumber(appendArgs)) {
        callArgs = Array.prototype.slice.call(arguments, 0) // copy arguments first
        const applyArgs = [appendArgs, 0].concat(args) // create method call params
        Array.prototype.splice.apply(callArgs, applyArgs) // splice them in
      }
      return method.apply(obj || window, callArgs)
    }
  },

  defer: function (millis, obj, args, appendArgs) {
    const fn = this.createDelegate(obj, args, appendArgs)
    if (millis > 0) {
      return setTimeout(fn, millis)
    }
    fn()
    return 0
  }
})

Ext.applyIf(String, {
  format: function (format) {
    const args = Ext.toArray(arguments, 1)
    return format.replace(/\{(\d+)\}/g, function (m, i) {
      return args[i]
    })
  }
})

Ext.applyIf(Array.prototype, {
  indexOf: function (o, from) {
    const len = this.length
    from = from || 0
    from += from < 0 ? len : 0
    for (; from < len; ++from) {
      if (this[from] === o) {
        return from
      }
    }
    return -1
  },

  remove: function (o) {
    const index = this.indexOf(o)
    if (index != -1) {
      this.splice(index, 1)
    }
    return this
  }
})

Ext.util.TaskRunner = function (interval) {
  interval = interval || 10
  let tasks = []
  let removeQueue = []
  let id = 0
  let running = false
  // private
  const stopThread = function () {
    running = false
    clearInterval(id)
    id = 0
  }
  // private
  const startThread = function () {
    if (!running) {
      running = true
      id = setInterval(runTasks, interval)
    }
  }
  // private
  const removeTask = function (t) {
    removeQueue.push(t)
    if (t.onStop) {
      t.onStop.apply(t.scope || t)
    }
  }
  // private
  const runTasks = function () {
    const rqLen = removeQueue.length
    const now = new Date().getTime()

    if (rqLen > 0) {
      for (let i = 0; i < rqLen; i++) {
        tasks.remove(removeQueue[i])
      }
      removeQueue = []
      if (tasks.length < 1) {
        stopThread()
        return
      }
    }
    for (let i = 0, t, itime, rt, len = tasks.length; i < len; ++i) {
      t = tasks[i]
      itime = now - t.taskRunTime
      if (t.interval <= itime) {
        rt = t.run.apply(t.scope || t, t.args || [++t.taskRunCount])
        t.taskRunTime = now
        if (rt === false || t.taskRunCount === t.repeat) {
          removeTask(t)
          return
        }
      }
      if (t.duration && t.duration <= now - t.taskStartTime) {
        removeTask(t)
      }
    }
  }

  this.start = function (task) {
    tasks.push(task)
    task.taskStartTime = new Date().getTime()
    task.taskRunTime = 0
    task.taskRunCount = 0
    startThread()
    return task
  }

  this.stop = function (task) {
    removeTask(task)
    return task
  }

  this.stopAll = function () {
    stopThread()
    for (let i = 0, len = tasks.length; i < len; i++) {
      if (tasks[i].onStop) {
        tasks[i].onStop()
      }
    }
    tasks = []
    removeQueue = []
  }
}

Ext.TaskMgr = new Ext.util.TaskRunner()

let libFlyweight

function fly(el) {
  if (!libFlyweight) {
    libFlyweight = new Ext.Element.Flyweight()
  }
  libFlyweight.dom = el
  return libFlyweight
}

const doc = document
const isCSS1 = doc.compatMode == 'CSS1Compat'
const MAX = Math.max
const ROUND = Math.round
const PARSEINT = parseInt

Ext.lib.Dom = {
  isAncestor: function (p, c) {
    let ret = false

    p = Ext.getDom(p)
    c = Ext.getDom(c)
    if (p && c) {
      if (p.contains) {
        return p.contains(c)
      } else if (p.compareDocumentPosition) {
        return !!(p.compareDocumentPosition(c) & 16)
      }
      while ((c = c.parentNode)) {
        ret = c == p || ret
      }
    }
    return ret
  },

  getViewWidth: function (full) {
    return full ? this.getDocumentWidth() : this.getViewportWidth()
  },

  getViewHeight: function (full) {
    return full ? this.getDocumentHeight() : this.getViewportHeight()
  },

  getDocumentHeight: function () {
    return MAX(
      !isCSS1 ? doc.body.scrollHeight : doc.documentElement.scrollHeight,
      this.getViewportHeight()
    )
  },

  getDocumentWidth: function () {
    return MAX(
      !isCSS1 ? doc.body.scrollWidth : doc.documentElement.scrollWidth,
      this.getViewportWidth()
    )
  },

  getViewportHeight: function () {
    return self.innerHeight
  },

  getViewportWidth: function () {
    return !Ext.isStrict ? doc.body.clientWidth : self.innerWidth
  },

  getY: function (el) {
    return this.getXY(el)[1]
  },

  getX: function (el) {
    return this.getXY(el)[0]
  },

  getXY: function (el) {
    let p
    let pe
    let b
    let bt
    let bl
    let dbd
    let x = 0
    let y = 0
    let scroll
    let hasAbsolute
    const bd = doc.body || doc.documentElement
    let ret = [0, 0]

    el = Ext.getDom(el)

    if (el != bd) {
      if (el.getBoundingClientRect) {
        b = el.getBoundingClientRect()
        scroll = fly(document).getScroll()
        ret = [ROUND(b.left + scroll.left), ROUND(b.top + scroll.top)]
      } else {
        p = el
        hasAbsolute = fly(el).isStyle('position', 'absolute')

        while (p) {
          pe = fly(p)
          x += p.offsetLeft
          y += p.offsetTop

          hasAbsolute = hasAbsolute || pe.isStyle('position', 'absolute')

          if (Ext.isGecko) {
            y += bt = PARSEINT(pe.getStyle('borderTopWidth'), 10) || 0
            x += bl = PARSEINT(pe.getStyle('borderLeftWidth'), 10) || 0

            if (p != el && !pe.isStyle('overflow', 'visible')) {
              x += bl
              y += bt
            }
          }
          p = p.offsetParent
        }

        if (Ext.isSafari && hasAbsolute) {
          x -= bd.offsetLeft
          y -= bd.offsetTop
        }

        if (Ext.isGecko && !hasAbsolute) {
          dbd = fly(bd)
          x += PARSEINT(dbd.getStyle('borderLeftWidth'), 10) || 0
          y += PARSEINT(dbd.getStyle('borderTopWidth'), 10) || 0
        }

        p = el.parentNode
        while (p && p != bd) {
          x -= p.scrollLeft
          y -= p.scrollTop

          p = p.parentNode
        }
        ret = [x, y]
      }
    }
    return ret
  },

  setXY: function (el, xy) {
    ;(el = Ext.fly(el, '_setXY')).position()

    const pts = el.translatePoints(xy)
    const style = el.dom.style
    let pos

    for (pos in pts) {
      if (!isNaN(pts[pos])) {
        style[pos] = pts[pos] + 'px'
      }
    }
  },

  setX: function (el, x) {
    this.setXY(el, [x, false])
  },

  setY: function (el, y) {
    this.setXY(el, [false, y])
  }
}

Ext.lib.Event = (function () {
  let loadComplete = false
  const unloadListeners = {}
  let retryCount = 0
  const onAvailStack = []
  let _interval
  let locked = false
  const win = window
  const doc = document
  // constants
  const POLL_RETRYS = 200
  const POLL_INTERVAL = 20
  const TYPE = 0
  const FN = 1
  const OBJ = 2
  const ADJ_SCOPE = 3
  const UNLOAD = 'unload'
  const MOUSEOVER = 'mouseover'
  const MOUSEOUT = 'mouseout'
  // private
  const doAdd = (function () {
    let ret
    if (win.addEventListener) {
      ret = function (el, eventName, fn, capture) {
        if (eventName == 'mouseenter') {
          fn = fn.createInterceptor(checkRelatedTarget)
          el.addEventListener(MOUSEOVER, fn, capture)
        } else if (eventName == 'mouseleave') {
          fn = fn.createInterceptor(checkRelatedTarget)
          el.addEventListener(MOUSEOUT, fn, capture)
        } else {
          el.addEventListener(eventName, fn, capture)
        }
        return fn
      }
    } else if (win.attachEvent) {
      ret = function (el, eventName, fn, capture) {
        el.attachEvent('on' + eventName, fn)
        return fn
      }
    } else {
      ret = function () {}
    }
    return ret
  })()
  // private
  const doRemove = (function () {
    let ret
    if (win.removeEventListener) {
      ret = function (el, eventName, fn, capture) {
        if (eventName == 'mouseenter') {
          eventName = MOUSEOVER
        } else if (eventName == 'mouseleave') {
          eventName = MOUSEOUT
        }
        el.removeEventListener(eventName, fn, capture)
      }
    } else if (win.detachEvent) {
      ret = function (el, eventName, fn) {
        el.detachEvent('on' + eventName, fn)
      }
    } else {
      ret = function () {}
    }
    return ret
  })()

  function checkRelatedTarget(e) {
    return !elContains(e.currentTarget, pub.getRelatedTarget(e))
  }

  function elContains(parent, child) {
    if (parent && parent.firstChild) {
      while (child) {
        if (child === parent) {
          return true
        }
        child = child.parentNode
        if (child && child.nodeType != 1) {
          child = null
        }
      }
    }
    return false
  }

  // private
  function _tryPreloadAttach() {
    let ret = false
    const notAvail = []
    let element
    let i
    let v
    let override
    const tryAgain = !loadComplete || retryCount > 0

    if (!locked) {
      locked = true

      for (i = 0; i < onAvailStack.length; ++i) {
        v = onAvailStack[i]
        if (v && (element = doc.getElementById(v.id))) {
          if (!v.checkReady || loadComplete || element.nextSibling || (doc && doc.body)) {
            override = v.override
            element = override ? (override === true ? v.obj : override) : element
            v.fn.call(element, v.obj)
            onAvailStack.remove(v)
            --i
          } else {
            notAvail.push(v)
          }
        }
      }

      retryCount = notAvail.length === 0 ? 0 : retryCount - 1

      if (tryAgain) {
        startInterval()
      } else {
        clearInterval(_interval)
        _interval = null
      }
      ret = !(locked = false)
    }
    return ret
  }

  // private
  function startInterval() {
    if (!_interval) {
      const callback = function () {
        _tryPreloadAttach()
      }
      _interval = setInterval(callback, POLL_INTERVAL)
    }
  }

  // private
  function getPageCoord(ev, xy) {
    ev = ev.browserEvent || ev
    let coord = ev['page' + xy]
    if (!coord && coord !== 0) {
      coord = ev['client' + xy] || 0
    }

    return coord
  }

  const pub = {
    extAdapter: true,
    onAvailable: function (p_id, p_fn, p_obj, p_override) {
      onAvailStack.push({
        id: p_id,
        fn: p_fn,
        obj: p_obj,
        override: p_override,
        checkReady: false
      })

      retryCount = POLL_RETRYS
      startInterval()
    },

    // This function should ALWAYS be called from Ext.EventManager
    addListener: function (el, eventName, fn) {
      el = Ext.getDom(el)
      if (el && fn) {
        if (eventName == UNLOAD) {
          if (unloadListeners[el.id] === undefined) {
            unloadListeners[el.id] = []
          }
          unloadListeners[el.id].push([eventName, fn])
          return fn
        }
        return doAdd(el, eventName, fn, false)
      }
      return false
    },

    // This function should ALWAYS be called from Ext.EventManager
    removeListener: function (el, eventName, fn) {
      el = Ext.getDom(el)
      let i, len, li, lis
      if (el && fn) {
        if (eventName == UNLOAD) {
          if ((lis = unloadListeners[el.id]) !== undefined) {
            for (i = 0, len = lis.length; i < len; i++) {
              if ((li = lis[i]) && li[TYPE] == eventName && li[FN] == fn) {
                unloadListeners[el.id].splice(i, 1)
              }
            }
          }
          return
        }
        doRemove(el, eventName, fn, false)
      }
    },

    getTarget: function (ev) {
      ev = ev.browserEvent || ev
      return this.resolveTextNode(ev.target || ev.srcElement)
    },

    resolveTextNode: Ext.isGecko
      ? function (node) {
          if (!node) {
            return
          }
          // work around firefox bug, https://bugzilla.mozilla.org/show_bug.cgi?id=101197
          const s = HTMLElement.prototype.toString.call(node)
          if (s == '[xpconnect wrapped native prototype]' || s == '[object XULElement]') {
            return
          }
          return node.nodeType == 3 ? node.parentNode : node
        }
      : function (node) {
          return node && node.nodeType == 3 ? node.parentNode : node
        },

    getRelatedTarget: function (ev) {
      ev = ev.browserEvent || ev
      return this.resolveTextNode(
        ev.relatedTarget ||
          (/(mouseout|mouseleave)/.test(ev.type)
            ? ev.toElement
            : /(mouseover|mouseenter)/.test(ev.type)
            ? ev.fromElement
            : null)
      )
    },

    getPageX: function (ev) {
      return getPageCoord(ev, 'X')
    },

    getPageY: function (ev) {
      return getPageCoord(ev, 'Y')
    },

    getXY: function (ev) {
      return [this.getPageX(ev), this.getPageY(ev)]
    },

    stopEvent: function (ev) {
      this.stopPropagation(ev)
      this.preventDefault(ev)
    },

    stopPropagation: function (ev) {
      ev = ev.browserEvent || ev
      if (ev.stopPropagation) {
        ev.stopPropagation()
      } else {
        ev.cancelBubble = true
      }
    },

    preventDefault: function (ev) {
      ev = ev.browserEvent || ev
      if (ev.preventDefault) {
        ev.preventDefault()
      } else {
        if (ev.keyCode) {
          ev.keyCode = 0
        }
        ev.returnValue = false
      }
    },

    getEvent: function (e) {
      e = e || win.event
      if (!e) {
        let c = this.getEvent.caller
        while (c) {
          e = c.arguments[0]
          if (e && Event == e.constructor) {
            break
          }
          c = c.caller
        }
      }
      return e
    },

    getCharCode: function (ev) {
      ev = ev.browserEvent || ev
      return ev.charCode || ev.keyCode || 0
    },

    // clearCache: function() {},
    // deprecated, call from EventManager
    getListeners: function (el, eventName) {
      Ext.EventManager.getListeners(el, eventName)
    },

    // deprecated, call from EventManager
    purgeElement: function (el, recurse, eventName) {
      Ext.EventManager.purgeElement(el, recurse, eventName)
    },

    _load: function (e) {
      loadComplete = true
    },

    _unload: function (e) {
      const EU = Ext.lib.Event
      let i
      let v
      let ul
      let id
      let len
      let scope

      for (id in unloadListeners) {
        ul = unloadListeners[id]
        for (i = 0, len = ul.length; i < len; i++) {
          v = ul[i]
          if (v) {
            try {
              scope = v[ADJ_SCOPE] ? (v[ADJ_SCOPE] === true ? v[OBJ] : v[ADJ_SCOPE]) : win
              v[FN].call(scope, EU.getEvent(e), v[OBJ])
            } catch (ex) {}
          }
        }
      }

      Ext.EventManager._unload()

      doRemove(win, UNLOAD, EU._unload)
    }
  }

  // Initialize stuff.
  pub.on = pub.addListener
  pub.un = pub.removeListener
  if (doc && doc.body) {
    pub._load(true)
  } else {
    doAdd(win, 'load', pub._load)
  }
  doAdd(win, UNLOAD, pub._unload)
  _tryPreloadAttach()

  return pub
})()

/*
 * Portions of this file are based on pieces of Yahoo User Interface Library
 * Copyright (c) 2007, Yahoo! Inc. All rights reserved.
 * YUI licensed under the BSD License:
 * http://developer.yahoo.net/yui/license.txt
 */
Ext.lib.Ajax = (function () {
  const activeX = ['Msxml2.XMLHTTP.3.0', 'Msxml2.XMLHTTP']
  const CONTENTTYPE = 'Content-Type'

  // private
  function setHeader(o) {
    const conn = o.conn
    let prop
    const headers = {}

    function setTheHeaders(conn, headers) {
      for (prop in headers) {
        if (headers.hasOwnProperty(prop)) {
          conn.setRequestHeader(prop, headers[prop])
        }
      }
    }

    Ext.apply(headers, pub.headers, pub.defaultHeaders)
    setTheHeaders(conn, headers)
    delete pub.headers
  }

  // private
  function createExceptionObject(tId, callbackArg, isAbort, isTimeout) {
    return {
      tId: tId,
      status: isAbort ? -1 : 0,
      statusText: isAbort ? 'transaction aborted' : 'communication failure',
      isAbort: isAbort,
      isTimeout: isTimeout,
      argument: callbackArg
    }
  }

  // private
  function initHeader(label, value) {
    ;(pub.headers = pub.headers || {})[label] = value
  }

  // private
  function createResponseObject(o, callbackArg) {
    const headerObj = {}
    let headerStr
    const conn = o.conn
    let t
    let s
    // see: https://prototype.lighthouseapp.com/projects/8886/tickets/129-ie-mangles-http-response-status-code-204-to-1223
    const isBrokenStatus = conn.status == 1223

    try {
      headerStr = o.conn.getAllResponseHeaders()
      Ext.each(headerStr.replace(/\r\n/g, '\n').split('\n'), function (v) {
        t = v.indexOf(':')
        if (t >= 0) {
          s = v.substr(0, t).toLowerCase()
          if (v.charAt(t + 1) == ' ') {
            ++t
          }
          headerObj[s] = v.substr(t + 1)
        }
      })
    } catch (e) {}

    return {
      tId: o.tId,
      // Normalize the status and statusText when IE returns 1223, see the above link.
      status: isBrokenStatus ? 204 : conn.status,
      statusText: isBrokenStatus ? 'No Content' : conn.statusText,
      getResponseHeader: function (header) {
        return headerObj[header.toLowerCase()]
      },
      getAllResponseHeaders: function () {
        return headerStr
      },
      responseText: conn.responseText,
      responseXML: conn.responseXML,
      argument: callbackArg
    }
  }

  // private
  function releaseObject(o) {
    if (o.tId) {
      pub.conn[o.tId] = null
    }
    o.conn = null
    o = null
  }

  // private
  function handleTransactionResponse(o, callback, isAbort, isTimeout) {
    if (!callback) {
      releaseObject(o)
      return
    }

    let httpStatus, responseObject

    try {
      if (o.conn.status !== undefined && o.conn.status != 0) {
        httpStatus = o.conn.status
      } else {
        httpStatus = 13030
      }
    } catch (e) {
      httpStatus = 13030
    }

    if (httpStatus >= 200 && httpStatus < 300) {
      responseObject = createResponseObject(o, callback.argument)
      if (callback.success) {
        if (!callback.scope) {
          callback.success(responseObject)
        } else {
          callback.success.apply(callback.scope, [responseObject])
        }
      }
    } else {
      switch (httpStatus) {
        case 12002:
        case 12029:
        case 12030:
        case 12031:
        case 12152:
        case 13030:
          responseObject = createExceptionObject(
            o.tId,
            callback.argument,
            isAbort || false,
            isTimeout
          )
          if (callback.failure) {
            if (!callback.scope) {
              callback.failure(responseObject)
            } else {
              callback.failure.apply(callback.scope, [responseObject])
            }
          }
          break
        default:
          responseObject = createResponseObject(o, callback.argument)
          if (callback.failure) {
            if (!callback.scope) {
              callback.failure(responseObject)
            } else {
              callback.failure.apply(callback.scope, [responseObject])
            }
          }
      }
    }

    releaseObject(o)
    responseObject = null
  }

  function checkResponse(o, callback, conn, tId, poll, cbTimeout) {
    if (conn && conn.readyState == 4) {
      clearInterval(poll[tId])
      poll[tId] = null

      if (cbTimeout) {
        clearTimeout(pub.timeout[tId])
        pub.timeout[tId] = null
      }
      handleTransactionResponse(o, callback)
    }
  }

  function checkTimeout(o, callback) {
    pub.abort(o, callback, true)
  }

  // private
  function handleReadyState(o, callback) {
    callback = callback || {}
    const conn = o.conn
    const tId = o.tId
    const poll = pub.poll
    const cbTimeout = callback.timeout || null

    if (cbTimeout) {
      pub.conn[tId] = conn
      pub.timeout[tId] = setTimeout(checkTimeout.createCallback(o, callback), cbTimeout)
    }
    poll[tId] = setInterval(
      checkResponse.createCallback(o, callback, conn, tId, poll, cbTimeout),
      pub.pollInterval
    )
  }

  // private
  function asyncRequest(method, uri, callback, postData) {
    const o = getConnectionObject() || null

    if (o) {
      o.conn.open(method, uri, true)

      if (pub.useDefaultXhrHeader) {
        initHeader('X-Requested-With', pub.defaultXhrHeader)
      }

      if (
        postData &&
        pub.useDefaultHeader &&
        (!pub.headers || !pub.headers[CONTENTTYPE])
      ) {
        initHeader(CONTENTTYPE, pub.defaultPostHeader)
      }

      if (pub.defaultHeaders || pub.headers) {
        setHeader(o)
      }

      handleReadyState(o, callback)
      o.conn.send(postData || null)
    }
    return o
  }

  // private
  function getConnectionObject() {
    let o

    try {
      if ((o = createXhrObject(pub.transactionId))) {
        pub.transactionId++
      }
    } catch (e) {
    } finally {
      // eslint-disable-next-line no-unsafe-finally
      return o
    }
  }

  // private
  function createXhrObject(transactionId) {
    let http

    try {
      http = new XMLHttpRequest()
    } catch (e) {
      for (let i = 0; i < activeX.length; ++i) {
        try {
          http = new ActiveXObject(activeX[i])
          break
        } catch (e) {}
      }
    } finally {
      // eslint-disable-next-line no-unsafe-finally
      return { conn: http, tId: transactionId }
    }
  }

  const pub = {
    request: function (method, uri, cb, data, options) {
      if (options) {
        const me = this
        const xmlData = options.xmlData
        const jsonData = options.jsonData
        let hs

        Ext.applyIf(me, options)

        if (xmlData || jsonData) {
          hs = me.headers
          if (!hs || !hs[CONTENTTYPE]) {
            initHeader(CONTENTTYPE, xmlData ? 'text/xml' : 'application/json')
          }
          data = xmlData || (!Ext.isPrimitive(jsonData) ? Ext.encode(jsonData) : jsonData)
        }
      }
      return asyncRequest(method || options.method || 'POST', uri, cb, data)
    },

    serializeForm: function (form) {
      const fElements =
        form.elements || (document.forms[form] || Ext.getDom(form)).elements
      let hasSubmit = false
      const encoder = encodeURIComponent
      let name
      let data = ''
      let type
      let hasValue

      Ext.each(fElements, function (element) {
        name = element.name
        type = element.type

        if (!element.disabled && name) {
          if (/select-(one|multiple)/i.test(type)) {
            Ext.each(element.options, function (opt) {
              if (opt.selected) {
                hasValue = opt.hasAttribute
                  ? opt.hasAttribute('value')
                  : opt.getAttributeNode('value').specified
                data += String.format(
                  '{0}={1}&',
                  encoder(name),
                  encoder(hasValue ? opt.value : opt.text)
                )
              }
            })
          } else if (!/file|undefined|reset|button/i.test(type)) {
            if (
              !(/radio|checkbox/i.test(type) && !element.checked) &&
              !(type == 'submit' && hasSubmit)
            ) {
              data += encoder(name) + '=' + encoder(element.value) + '&'
              hasSubmit = /submit/i.test(type)
            }
          }
        }
      })
      return data.substr(0, data.length - 1)
    },

    useDefaultHeader: true,
    defaultPostHeader: 'application/x-www-form-urlencoded; charset=UTF-8',
    useDefaultXhrHeader: true,
    defaultXhrHeader: 'XMLHttpRequest',
    poll: {},
    timeout: {},
    conn: {},
    pollInterval: 50,
    transactionId: 0,

    abort: function (o, callback, isTimeout) {
      const me = this
      const tId = o.tId
      let isAbort = false

      if (me.isCallInProgress(o)) {
        o.conn.abort()
        clearInterval(me.poll[tId])
        me.poll[tId] = null
        clearTimeout(pub.timeout[tId])
        me.timeout[tId] = null

        handleTransactionResponse(o, callback, (isAbort = true), isTimeout)
      }
      return isAbort
    },

    isCallInProgress: function (o) {
      // if there is a connection and readyState is not 0 or 4
      return o.conn && !{ 0: true, 4: true }[o.conn.readyState]
    }
  }
  return pub
})()

const EXTLIB = Ext.lib
const noNegatives = /width|height|opacity|padding/i
const offsetAttribute = /^((width|height)|(top|left))$/
const defaultUnit = /width|height|top$|bottom$|left$|right$/i
const offsetUnit = /\d+(em|%|en|ex|pt|in|cm|mm|pc)$/i
const now = function () {
  return new Date()
}

EXTLIB.Anim = {
  motion: function (el, args, duration, easing, cb, scope) {
    return this.run(el, args, duration, easing, cb, scope, Ext.lib.Motion)
  },

  run: function (el, args, duration, easing, cb, scope, type) {
    type = type || Ext.lib.AnimBase
    if (typeof easing === 'string') {
      easing = Ext.lib.Easing[easing]
    }
    const anim = new type(el, args, duration, easing)
    anim.animateX(function () {
      if (Ext.isFunction(cb)) {
        cb.call(scope)
      }
    })
    return anim
  }
}

EXTLIB.AnimBase = function (el, attributes, duration, method) {
  if (el) {
    this.init(el, attributes, duration, method)
  }
}

EXTLIB.AnimBase.prototype = {
  doMethod: function (attr, start, end) {
    const me = this
    return me.method(me.curFrame, start, end - start, me.totalFrames)
  },

  setAttr: function (attr, val, unit) {
    if (noNegatives.test(attr) && val < 0) {
      val = 0
    }
    Ext.fly(this.el, '_anim').setStyle(attr, val + unit)
  },

  getAttr: function (attr) {
    const el = Ext.fly(this.el)
    const val = el.getStyle(attr)
    const a = offsetAttribute.exec(attr) || []

    if (val !== 'auto' && !offsetUnit.test(val)) {
      return parseFloat(val)
    }

    return !!a[2] || (el.getStyle('position') == 'absolute' && !!a[3])
      ? el.dom['offset' + a[0].charAt(0).toUpperCase() + a[0].substr(1)]
      : 0
  },

  getDefaultUnit: function (attr) {
    return defaultUnit.test(attr) ? 'px' : ''
  },

  animateX: function (callback, scope) {
    const me = this
    const f = function () {
      me.onComplete.removeListener(f)
      if (Ext.isFunction(callback)) {
        callback.call(scope || me, me)
      }
    }
    me.onComplete.addListener(f, me)
    me.animate()
  },

  setRunAttr: function (attr) {
    const me = this
    const a = this.attributes[attr]
    const to = a.to
    const by = a.by
    const from = a.from
    const unit = a.unit
    const ra = (this.runAttrs[attr] = {})
    let end

    if (!isset(to) && !isset(by)) {
      return false
    }

    const start = isset(from) ? from : me.getAttr(attr)
    if (isset(to)) {
      end = to
    } else if (isset(by)) {
      if (Array.isArray(start)) {
        end = []
        for (let i = 0, len = start.length; i < len; i++) {
          end[i] = start[i] + by[i]
        }
      } else {
        end = start + by
      }
    }

    Ext.apply(ra, {
      start: start,
      end: end,
      unit: isset(unit) ? unit : me.getDefaultUnit(attr)
    })
  },

  init: function (el, attributes, duration, method) {
    const me = this
    let actualFrames = 0
    const mgr = EXTLIB.AnimMgr

    Ext.apply(me, {
      isAnimated: false,
      startTime: null,
      el: Ext.getDom(el),
      attributes: attributes || {},
      duration: duration || 1,
      method: method || EXTLIB.Easing.easeNone,
      useSec: true,
      curFrame: 0,
      totalFrames: mgr.fps,
      runAttrs: {},
      animate: function () {
        const me = this
        const d = me.duration

        if (me.isAnimated) {
          return false
        }

        me.curFrame = 0
        me.totalFrames = me.useSec ? Math.ceil(mgr.fps * d) : d
        mgr.registerElement(me)
      },

      stop: function (finish) {
        const me = this

        if (finish) {
          me.curFrame = me.totalFrames
          me._onTween.fire()
        }
        mgr.stop(me)
      }
    })

    const onStart = function () {
      const me = this
      let attr

      me.onStart.fire()
      me.runAttrs = {}
      for (attr in this.attributes) {
        this.setRunAttr(attr)
      }

      me.isAnimated = true
      me.startTime = now()
      actualFrames = 0
    }

    const onTween = function () {
      const me = this

      me.onTween.fire({
        duration: now() - me.startTime,
        curFrame: me.curFrame
      })

      const ra = me.runAttrs
      for (const attr in ra) {
        this.setAttr(attr, me.doMethod(attr, ra[attr].start, ra[attr].end), ra[attr].unit)
      }

      ++actualFrames
    }

    const onComplete = function () {
      const me = this
      const actual = (now() - me.startTime) / 1000
      const data = {
        duration: actual,
        frames: actualFrames,
        fps: actualFrames / actual
      }

      me.isAnimated = false
      actualFrames = 0
      me.onComplete.fire(data)
    }

    me.onStart = new Ext.util.Event(me)
    me.onTween = new Ext.util.Event(me)
    me.onComplete = new Ext.util.Event(me)
    ;(me._onStart = new Ext.util.Event(me)).addListener(onStart)
    ;(me._onTween = new Ext.util.Event(me)).addListener(onTween)
    ;(me._onComplete = new Ext.util.Event(me)).addListener(onComplete)
  }
}

Ext.lib.AnimMgr = new (function () {
  const me = this
  let thread = null
  let queue = []
  let tweenCount = 0

  Ext.apply(me, {
    fps: 1000,
    delay: 1,
    registerElement: function (tween) {
      queue.push(tween)
      ++tweenCount
      tween._onStart.fire()
      me.start()
    },

    unRegister: function (tween, index) {
      tween._onComplete.fire()
      index = index || getIndex(tween)
      if (index != -1) {
        queue.splice(index, 1)
      }

      if (--tweenCount <= 0) {
        me.stop()
      }
    },

    start: function () {
      if (thread === null) {
        thread = setInterval(me.run, me.delay)
      }
    },

    stop: function (tween) {
      if (!tween) {
        clearInterval(thread)
        for (let i = 0, len = queue.length; i < len; ++i) {
          if (queue[0].isAnimated) {
            me.unRegister(queue[0], 0)
          }
        }

        queue = []
        thread = null
        tweenCount = 0
      } else {
        me.unRegister(tween)
      }
    },

    run: function () {
      let tf, i, len, tween
      for (i = 0, len = queue.length; i < len; i++) {
        tween = queue[i]
        if (tween && tween.isAnimated) {
          tf = tween.totalFrames
          if (tween.curFrame < tf || tf === null) {
            ++tween.curFrame
            if (tween.useSec) {
              correctFrame(tween)
            }
            tween._onTween.fire()
          } else {
            me.stop(tween)
          }
        }
      }
    }
  })

  const getIndex = function (anim) {
    let i, len
    for (i = 0, len = queue.length; i < len; i++) {
      if (queue[i] === anim) {
        return i
      }
    }
    return -1
  }

  const correctFrame = function (tween) {
    const frames = tween.totalFrames
    const frame = tween.curFrame
    const duration = tween.duration
    const expected = (frame * duration * 1000) / frames
    const elapsed = now() - tween.startTime
    let tweak = 0

    if (elapsed < duration * 1000) {
      tweak = Math.round((elapsed / expected - 1) * frame)
    } else {
      tweak = frames - (frame + 1)
    }
    if (tweak > 0 && isFinite(tweak)) {
      if (tween.curFrame + tweak >= frames) {
        tweak = frames - (frame + 1)
      }
      tween.curFrame += tweak
    }
  }
})()

EXTLIB.Bezier = new (function () {
  this.getPosition = function (points, t) {
    const n = points.length
    const tmp = []
    const c = 1 - t
    let i
    let j

    for (i = 0; i < n; ++i) {
      tmp[i] = [points[i][0], points[i][1]]
    }

    for (j = 1; j < n; ++j) {
      for (i = 0; i < n - j; ++i) {
        tmp[i][0] = c * tmp[i][0] + t * tmp[parseInt(i + 1, 10)][0]
        tmp[i][1] = c * tmp[i][1] + t * tmp[parseInt(i + 1, 10)][1]
      }
    }

    return [tmp[0][0], tmp[0][1]]
  }
})()

EXTLIB.Easing = {
  easeNone: function (t, b, c, d) {
    return (c * t) / d + b
  },

  easeIn: function (t, b, c, d) {
    return c * (t /= d) * t + b
  },

  easeOut: function (t, b, c, d) {
    return -c * (t /= d) * (t - 2) + b
  }
}

EXTLIB.Motion = function (el, attributes, duration, method) {
  if (el) {
    EXTLIB.Motion.superclass.constructor.call(this, el, attributes, duration, method)
  }
}

Ext.extend(EXTLIB.Motion, Ext.lib.AnimBase)

const pointsRe = /^points$/i

Ext.apply(EXTLIB.Motion.prototype, {
  setAttr: function (attr, val, unit) {
    const me = this
    const setAttr = EXTLIB.Motion.superclass.setAttr

    if (pointsRe.test(attr)) {
      unit = unit || 'px'
      setAttr.call(me, 'left', val[0], unit)
      setAttr.call(me, 'top', val[1], unit)
    } else {
      setAttr.call(me, attr, val, unit)
    }
  },

  getAttr: function (attr) {
    const me = this
    const getAttr = EXTLIB.Motion.superclass.getAttr

    return pointsRe.test(attr)
      ? [getAttr.call(me, 'left'), getAttr.call(me, 'top')]
      : getAttr.call(me, attr)
  },

  doMethod: function (attr, start, end) {
    const me = this

    return pointsRe.test(attr)
      ? EXTLIB.Bezier.getPosition(
          me.runAttrs[attr],
          me.method(me.curFrame, 0, 100, me.totalFrames) / 100
        )
      : EXTLIB.Motion.superclass.doMethod.call(me, attr, start, end)
  },

  setRunAttr: function (attr) {
    if (pointsRe.test(attr)) {
      const me = this
      const el = this.el
      const points = this.attributes.points
      let control = points.control || []
      const from = points.from
      const to = points.to
      const by = points.by
      const DOM = EXTLIB.Dom
      let i
      let end
      let len
      let ra

      if (control.length > 0 && !Array.isArray(control[0])) {
        control = [control]
      }

      Ext.fly(el, '_anim').position()
      DOM.setXY(el, isset(from) ? from : DOM.getXY(el))
      const start = me.getAttr('points')

      if (isset(to)) {
        end = translateValues.call(me, to, start)
        for (i = 0, len = control.length; i < len; ++i) {
          control[i] = translateValues.call(me, control[i], start)
        }
      } else if (isset(by)) {
        end = [start[0] + by[0], start[1] + by[1]]

        for (i = 0, len = control.length; i < len; ++i) {
          control[i] = [start[0] + control[i][0], start[1] + control[i][1]]
        }
      }

      ra = this.runAttrs[attr] = [start]
      if (control.length > 0) {
        ra = ra.concat(control)
      }

      ra[ra.length] = end
    } else {
      EXTLIB.Motion.superclass.setRunAttr.call(this, attr)
    }
  }
})

const translateValues = function (val, start) {
  const pageXY = EXTLIB.Dom.getXY(this.el)
  return [val[0] - pageXY[0] + start[0], val[1] - pageXY[1] + start[1]]
}

const abs = Math.abs
const pi = Math.PI
const asin = Math.asin
const pow = Math.pow
const sin = Math.sin

Ext.apply(EXTLIB.Easing, {
  easeBoth: function (t, b, c, d) {
    return (t /= d / 2) < 1 ? (c / 2) * t * t + b : (-c / 2) * (--t * (t - 2) - 1) + b
  },

  easeInStrong: function (t, b, c, d) {
    return c * (t /= d) * t * t * t + b
  },

  easeOutStrong: function (t, b, c, d) {
    return -c * ((t = t / d - 1) * t * t * t - 1) + b
  },

  easeBothStrong: function (t, b, c, d) {
    return (t /= d / 2) < 1
      ? (c / 2) * t * t * t * t + b
      : (-c / 2) * ((t -= 2) * t * t * t - 2) + b
  },

  elasticIn: function (t, b, c, d, a, p) {
    if (t == 0 || (t /= d) == 1) {
      return t == 0 ? b : b + c
    }
    p = p || d * 0.3

    let s
    if (a >= abs(c)) {
      s = (p / (2 * pi)) * asin(c / a)
    } else {
      a = c
      s = p / 4
    }

    return -(a * pow(2, 10 * (t -= 1)) * sin(((t * d - s) * (2 * pi)) / p)) + b
  },

  elasticOut: function (t, b, c, d, a, p) {
    if (t == 0 || (t /= d) == 1) {
      return t == 0 ? b : b + c
    }
    p = p || d * 0.3

    let s
    if (a >= abs(c)) {
      s = (p / (2 * pi)) * asin(c / a)
    } else {
      a = c
      s = p / 4
    }

    return a * pow(2, -10 * t) * sin(((t * d - s) * (2 * pi)) / p) + c + b
  },

  elasticBoth: function (t, b, c, d, a, p) {
    if (t == 0 || (t /= d / 2) == 2) {
      return t == 0 ? b : b + c
    }

    p = p || d * (0.3 * 1.5)

    let s
    if (a >= abs(c)) {
      s = (p / (2 * pi)) * asin(c / a)
    } else {
      a = c
      s = p / 4
    }

    return t < 1
      ? -0.5 * (a * pow(2, 10 * (t -= 1)) * sin(((t * d - s) * (2 * pi)) / p)) + b
      : a * pow(2, -10 * (t -= 1)) * sin(((t * d - s) * (2 * pi)) / p) * 0.5 + c + b
  },

  backIn: function (t, b, c, d, s) {
    s = s || 1.70158
    return c * (t /= d) * t * ((s + 1) * t - s) + b
  },

  backOut: function (t, b, c, d, s) {
    if (!s) {
      s = 1.70158
    }
    return c * ((t = t / d - 1) * t * ((s + 1) * t + s) + 1) + b
  },

  backBoth: function (t, b, c, d, s) {
    s = s || 1.70158

    return (t /= d / 2) < 1
      ? (c / 2) * (t * t * (((s *= 1.525) + 1) * t - s)) + b
      : (c / 2) * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2) + b
  },

  bounceIn: function (t, b, c, d) {
    return c - EXTLIB.Easing.bounceOut(d - t, 0, c, d) + b
  },

  bounceOut: function (t, b, c, d) {
    if ((t /= d) < 1 / 2.75) {
      return c * (7.5625 * t * t) + b
    } else if (t < 2 / 2.75) {
      return c * (7.5625 * (t -= 1.5 / 2.75) * t + 0.75) + b
    } else if (t < 2.5 / 2.75) {
      return c * (7.5625 * (t -= 2.25 / 2.75) * t + 0.9375) + b
    }
    return c * (7.5625 * (t -= 2.625 / 2.75) * t + 0.984375) + b
  },

  bounceBoth: function (t, b, c, d) {
    return t < d / 2
      ? EXTLIB.Easing.bounceIn(t * 2, 0, c, d) * 0.5 + b
      : EXTLIB.Easing.bounceOut(t * 2 - d, 0, c, d) * 0.5 + c * 0.5 + b
  }
})

// Color Animation
EXTLIB.Anim.color = function (el, args, duration, easing, cb, scope) {
  return EXTLIB.Anim.run(el, args, duration, easing, cb, scope, EXTLIB.ColorAnim)
}

EXTLIB.ColorAnim = function (el, attributes, duration, method) {
  EXTLIB.ColorAnim.superclass.constructor.call(this, el, attributes, duration, method)
}

Ext.extend(EXTLIB.ColorAnim, EXTLIB.AnimBase)

const colorRE = /color$/i
const transparentRE = /^transparent|rgba\(0, 0, 0, 0\)$/
const rgbRE = /^rgb\(([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9]+)\)$/i
const hexRE = /^#?([0-9A-F]{2})([0-9A-F]{2})([0-9A-F]{2})$/i
const hex3RE = /^#?([0-9A-F]{1})([0-9A-F]{1})([0-9A-F]{1})$/i
const isset = function (v) {
  return typeof v !== 'undefined'
}

// private
function parseColor(s) {
  const pi = parseInt
  let base
  let out = null
  let c

  if (s.length == 3) {
    return s
  }

  Ext.each([hexRE, rgbRE, hex3RE], function (re, idx) {
    base = idx % 2 == 0 ? 16 : 10
    c = re.exec(s)
    if (c && c.length == 4) {
      out = [pi(c[1], base), pi(c[2], base), pi(c[3], base)]
      return false
    }
  })
  return out
}

Ext.apply(EXTLIB.ColorAnim.prototype, {
  getAttr: function (attr) {
    const me = this
    let el = me.el
    let val
    if (colorRE.test(attr)) {
      while (el && transparentRE.test((val = Ext.fly(el).getStyle(attr)))) {
        el = el.parentNode
        val = 'fff'
      }
    } else {
      val = EXTLIB.ColorAnim.superclass.getAttr.call(me, attr)
    }
    return val
  },

  doMethod: function (attr, start, end) {
    const me = this
    let val
    const floor = Math.floor
    let i
    let len
    let v

    if (colorRE.test(attr)) {
      val = []
      end = end || []

      for (i = 0, len = start.length; i < len; i++) {
        v = start[i]
        val[i] = EXTLIB.ColorAnim.superclass.doMethod.call(me, attr, v, end[i])
      }
      val = 'rgb(' + floor(val[0]) + ',' + floor(val[1]) + ',' + floor(val[2]) + ')'
    } else {
      val = EXTLIB.ColorAnim.superclass.doMethod.call(me, attr, start, end)
    }
    return val
  },

  setRunAttr: function (attr) {
    const me = this
    const a = me.attributes[attr]
    const to = a.to
    const by = a.by

    EXTLIB.ColorAnim.superclass.setRunAttr.call(me, attr)
    const ra = me.runAttrs[attr]
    if (colorRE.test(attr)) {
      const start = parseColor(ra.start)
      let end = parseColor(ra.end)

      if (!isset(to) && isset(by)) {
        end = parseColor(by)
        for (let i = 0, len = start.length; i < len; i++) {
          end[i] = start[i] + end[i]
        }
      }
      ra.start = start
      ra.end = end
    }
  }
})

EXTLIB.Anim.scroll = function (el, args, duration, easing, cb, scope) {
  return EXTLIB.Anim.run(el, args, duration, easing, cb, scope, EXTLIB.Scroll)
}

EXTLIB.Scroll = function (el, attributes, duration, method) {
  if (el) {
    EXTLIB.Scroll.superclass.constructor.call(this, el, attributes, duration, method)
  }
}

Ext.extend(EXTLIB.Scroll, EXTLIB.ColorAnim)

const SCROLL = 'scroll'

Ext.apply(EXTLIB.Scroll.prototype, {
  doMethod: function (attr, start, end) {
    let val
    const me = this
    const curFrame = me.curFrame
    const totalFrames = me.totalFrames

    if (attr == SCROLL) {
      val = [
        me.method(curFrame, start[0], end[0] - start[0], totalFrames),
        me.method(curFrame, start[1], end[1] - start[1], totalFrames)
      ]
    } else {
      val = EXTLIB.Scroll.superclass.doMethod.call(me, attr, start, end)
    }
    return val
  },

  getAttr: function (attr) {
    const me = this

    if (attr == SCROLL) {
      return [me.el.scrollLeft, me.el.scrollTop]
    }
    return EXTLIB.Scroll.superclass.getAttr.call(me, attr)
  },

  setAttr: function (attr, val, unit) {
    const me = this

    if (attr == SCROLL) {
      me.el.scrollLeft = val[0]
      me.el.scrollTop = val[1]
    } else {
      EXTLIB.Scroll.superclass.setAttr.call(me, attr, val, unit)
    }
  }
})

module.exports = Ext
